<app-clone-log-grid (mySelected)="grid_onSelected($event)"></app-clone-log-grid>

